import { api as deTicketApi } from '@/core/api';
import { convertToBlob } from '@/utils/utilities.js';

export const getItemSearchResults = async (criteria) => {
  return await deTicketApi.post('/api/item/search', criteria);
};

export const getDefaultItemList = async (criteria) => {
  return await deTicketApi.get('/api/item/search', criteria);
};

export const getApplications = () => deTicketApi.get('/api/application/list');

export const getInitCatalog = () => deTicketApi.get('/api/item/initcatalog');

export const getMipeScreens = (moduleId) => {
  return deTicketApi.get(`/api/mipeapps/screens/${moduleId}`);
};

export const getScreensByModuleId = (moduleId) =>
  deTicketApi.get('/api/screen/list', {
    params: {
      moduleId,
    },
  });

export const saveTicket = (payload) =>
  deTicketApi.post('/api/ticket/save', payload);

export const updateTicket = (payload) =>
  deTicketApi.put('/api/ticket/update', payload);

export const getCase = (businessId) =>
  deTicketApi.get('/api/item/getcase', {
    params: {
      businessId,
    },
  });

export const getTrackingEntries = (businessId, isCurrent) =>
  deTicketApi.get('/api/trackingentry/withoutcommentevents', {
    params: {
      businessId,
      isCurrent,
    },
  });

export const getComments = (businessId, isCurrent) =>
  deTicketApi.get('/api/trackingentry/withcommentevents', {
    params: {
      businessId,
      isCurrent,
    },
  });

export const addComment = (businessId, commentText) =>
  deTicketApi.post('/api/trackingentry/addcomment', {
    businessId,
    commentText,
  });

export const getAssigmentUsers = (businessId) =>
  deTicketApi.get('/api/itemassignment/users', {
    params: {
      businessId,
    },
  });

export const unAssignUserFromItem = (businessId, userId) =>
  deTicketApi.post(`/api/item/unassignuserfromitem/${businessId}/${userId}`);

export const getAvailableStatus = (businessId) =>
  deTicketApi.get(`/api/item/availableworkflowstatus/${businessId}`);

export const getAllStatus = () => deTicketApi.get(`/api/itemstatus/list`);

export const saveStatusChange = (
  businessId,
  itemId,
  newStatusId,
  newStatusDescription,
  newStatusComment
) =>
  deTicketApi.post('/api/item/savestatuschange', {
    businessId,
    itemId,
    newStatusId,
    newStatusDescription,
    newStatusComment,
  });

export const getItemBadgeTotal = (businessId) =>
  deTicketApi.get(`/api/item/itembadgetotal/${businessId}`);

export const getProfileUsers = (businessId) =>
  deTicketApi.get(`api/item/profileusers/${businessId}`);

export const assignUserToItem = (businessId, payload) =>
  deTicketApi.post(`/api/item/assignuser/${businessId}`, payload);

export const getAttachmentCategories = () =>
  deTicketApi.get('/api/attachmentcategory/list');

export const saveItemAttachment = (data) => {
  return deTicketApi.post('/api/itemattachment/saveitemattachment', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const downloadItemAttachment = async (id) => {
  const { data } = await deTicketApi.get(`/api/itemattachment/download/${id}`);
  if (data) {
    convertToBlob(data);
  }
};

export const getItemAttachments = (businessId) =>
  deTicketApi.get('/api/itemattachment/attachments', {
    params: {
      businessId,
    },
  });

export const removeItemAttachment = (businessId) =>
  deTicketApi.delete(`/api/itemattachment/remove/${businessId}`);

export const initAttachmentCatalog = () =>
  deTicketApi.get('/api/itemattachment/initcatalog');

export const getConfiguredStatuses = (itemSubTypeId) =>
  deTicketApi.get(`/api/workflow/statuses/${itemSubTypeId}`);

export const getApplicationModules = (applicationId) =>
  deTicketApi.get('/api/module/list', { params: { applicationId } });

export const getModules = (applicationId) =>
  deTicketApi.get(`/api/mipeapps/modules/${applicationId}`);

export const getDashboardInfo = () =>
  deTicketApi.get('/api/item/dashboardinfo');

export const setCommentActiveStatus = (commentId, activeStatus) =>
  deTicketApi.get(
    `/api/trackingentry/comments/${commentId}/setactive/${activeStatus}`
  );

export const getPendingItems = (days) =>
  deTicketApi.get(`/api/item/pendingitems/${days}`);

export const getWorkflowStatusList = (businessId) =>
  deTicketApi.get(`/api/workflow/workflowstatus/${businessId}`);

export const getAllItemsSearchResults = async () => {
  return await deTicketApi.get('/api/item/search/all');
};

export const getReferenceNumberTypes = (params) =>
  deTicketApi.get(`/api/item/referencenumbertypes`, { params: params });

export const getTechnicalUsersAssigned = () =>
  deTicketApi.get(`/api/item/technicalusersassigned`);

export const massiveAssign = (params) =>
  deTicketApi.post(`/api/item/massiveassign`, params);

export const getUnassignedItems = (profileId) =>
  deTicketApi.get(`/api/item/search/unassigned/${profileId}`);
